import ScannerEvent from "@/ScannerEvents/ScannerEvent";

export default class StockEvent extends ScannerEvent {
    constructor(colorId, finishId, fallbackColorName, fallbackFinishName) {
        super();

        this.colorId = colorId;
        this.finishId = finishId;
        this.fallbackColorName = fallbackColorName;
        this.fallbackFinishName = fallbackFinishName;
    }

    static MatchesType(type) {
        return type === "s";
    }

    static ParseData(jsonData) {
        return new StockEvent(
            jsonData.c_id,
            jsonData.f_id,
            jsonData.fn,
            jsonData.ff
        );
    }
}
